import { CurrencyService } from './../../../../modules/shared/services/currency.service';
import { TimeZoneService } from './../../../../modules/shared/services/timezone.service';
import { Status } from './../../../../modules/shared/models/status';
import { PurchasesService } from './../../../../inventory/purchases/purchases.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from "lodash";
import { MessageService } from 'primeng/api';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { AccountGroupId } from 'src/app/accounts/account.enum';
import { AccountService } from 'src/app/accounts/accountService';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { CrmAccountFieldService } from 'src/app/configurations/crm/account/fields/fields.service';
import { PaymentmethodService } from 'src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service';
import { PaymenttermService } from 'src/app/configurations/inventory/setup/paymentterm/paymentterm.service';
import { ShippingmethodService } from 'src/app/configurations/inventory/setup/shippingmethod/shippingmethod.service';
import { ShippingtermService } from 'src/app/configurations/inventory/setup/shippingterm/shippingterm.service';
import { ContactService } from 'src/app/contacts/contactService';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { TypeIds } from 'src/app/inventory/sales-order/constants/constants';
import { UtilityService } from 'src/app/inventory/sales-order/utils/utility.service';
import { LeadService } from 'src/app/leads/leadService';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { EstimateStatusObjects, InvoicePaymentStatusEnumObjects, InvoiceStatusObjects, OrderStatusObjects, RatingValueObjects, SalesOrderStageEnumObjects, SalesOrderStatusEnumObjects, SavedSearchParentModule, ShipmentStatusObjects, TaxPreferenceObjects } from 'src/app/misc/saved-searches/models/saved-search.static';
import { SavedSearchesService } from 'src/app/misc/saved-searches/services/saved-searches.service';
import { AppRuleSelectionService } from 'src/app/modules/shared/components/rule-selection/app.rule.selection.service';
import { TypeGroupIds } from 'src/app/modules/shared/constants/category-groupid.constants';
import { CUSTOMFIELD_TYPE_IDS } from 'src/app/modules/shared/constants/typeId';
import { AccountsHttpService } from 'src/app/modules/shared/services/accounts.http.service';
import { WorkflowModelsNS } from '../../models/add-update-workflow.models';
import { LeadAccountUpdateFieldSectionsModel, LeadAccountUpdateFieldsModel } from '../../models/lead-account-update-fields.models';
import { WF_BUNDLE_PRODUCT_UPDATE_FIELDS, WF_IN_PRODUCT_UPDATE_FIELDS, WF_KIT_PRODUCT_UPDATE_FIELDS, WF_NON_PRODUCT_UPDATE_FIELDS, WF_SERVICE_PRODUCT_UPDATE_FIELDS, WF_SO_UPDATE_FIELDS } from '../../models/workflow-sales-order-fields.constants';
import { SalesOrderService } from './../../../../inventory/sales-order/sales-order.service';
import { StatusGroupIds } from './../../../../modules/shared/constants/category-groupid.constants';
import { customFieldTagRegex } from './../../../../modules/shared/constants/custom-field-tag.regex';
import { FormControlList, FormControlListIds, getFormControlNameById } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { AccountModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, LeadModuleId, OpportunityModuleId, OrderModuleId, ProductModuleId, PurchaseOrderModuleId, SOModuleId, VendorModuleId } from './../../../../modules/shared/constants/modules.constant';
import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { SharedTemplateService } from './../../../../modules/shared/services/template.service';
import { WF_VENDOR_UPDATE_FIELDS } from '../../models/workflow-vendor-fields.constants';
import { ObjectNames } from 'src/app/inventory/constants/constants';
import { WorkflowCurrentDateFields } from '../../models/workflow.static';
import { WF_PO_FORM_FIELDS } from '../../models/workflow-purchase-order-field.constants';

@Component({
  selector: 'app-workflow-update-field-dialog',
  templateUrl: './workflow-update-field-dialog.component.html',
  styleUrls: ['./workflow-update-field-dialog.component.scss']
})
export class WorkflowUpdateFieldDialogComponent implements OnInit, OnDestroy, OnChanges {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() viewOnly: boolean = false;
    @Input() displayAddField: boolean = false;
    @Input() selectedActionField: WorkflowModelsNS.WorkflowAddEditActionUpdateFields = null;
    @Input() parentModules: SavedSearchNS.IObjectType[] = [];
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() addedFields: string[] = [];
    @Input() selectedParentTemplate: SavedSearchNS.ITemplate;// Parent module Template
    @Input() selectedAccountChannel = null;
    @Input() selectedActionModule: any = null;
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() fieldSaved = new EventEmitter<any>();

    selectedModule: { objectId: number, name: string } = null;
    selectedChannelId: number = 0;

    currentColList: LeadAccountUpdateFieldSectionsModel[] = [];
    hiddenFields: string[] = [
        'sequenceNumber','phone','contactEmail',
        'contactname','contactFirstName','contactMiddleName','contactLastName',
        'social','businessName','work','mainCustomer',
        'name','forcastCategory','probability',
        'createdDate','createdByUserName','updatedDate','updatedByUserName',
        'previousStageOwner', 'stageChangedBy','previousStage','stageChangedDate','contactSequenceNumber'
    ];
    hiddenChildFields: string[] = ['contactEmail','phone'];
    treeSelectFields: string[] = ['shippingmethodid','shippingmethod','class','cogs','income','asset','incomeaccount','expenseaccount'];
    multiTreeSelectFields: string[] = ['category','uom'];
    availableFields: SavedSearchNS.IField[] = [];
    availableFieldsForExpression: SavedSearchNS.IField[] = [];
    //Workflow details form
    fieldAddEditHeader: string = 'Add Update Field';
    fieldDetailsForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    selectedNewFieldValue: string = "";
    dropdownValues: any[] = [];
    customFieldIds = CUSTOMFIELD_TYPE_IDS;
    accountModuleId = AccountModuleId;
    leadModuleId = LeadModuleId;
    salesOrderModuleId = SOModuleId;
    estimateOrderModuleId = EstimateOrderModuleId;
    invoiceOrderModuleId = InvoiceOrderModuleId;

    operationModules: number[] = [AccountModuleId,LeadModuleId,OpportunityModuleId,VendorModuleId];
    operationFormControlIds: number[] = [CUSTOMFIELD_TYPE_IDS.MULTISELECT,CUSTOMFIELD_TYPE_IDS.CHECKBOX];
    operationTypes: {id: number, name: string}[] = [
        {id: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update, name: 'Replace'},
        {id: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Append, name: 'Append'},
        {id: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Remove, name: 'Remove'}
    ];

    //Sales Order
    orderTemplates: any[] = [];
    salesOrderTemplates: any[] = [];
    orderObjId: number = OrderModuleId;
    orderCustomAttributes: any[] = [];
    combinedCustomFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };

    //Product Update
    productTypeIds = TypeIds;
    currencySymbol: string = "";

    //Add Expression
    displayAddExpression: boolean = false;
    expressionText: string = "";
    addedFieldTags: string[] = [];
    showEncryptedText: boolean = false;

    allShippingTerms: any[] = [];

    constructor(
        private formBuilder: FormBuilder,
        public app: AppMainComponent,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private configService: ConfigurationService,
        private ruleService: AppRuleSelectionService,
        private savedSearchesService: SavedSearchesService,
        private leadService: LeadService,
        private accountService: AccountService,
        private accountsHttpService: AccountsHttpService,
        private fieldService: CrmAccountFieldService,
        private contactService: ContactService,
        private productsService: ProductsService,
        private purchaseService: PurchasesService,
        private paymenttermService: PaymenttermService,
        private paymentmethodService: PaymentmethodService,
        private shippingtermService: ShippingtermService,
        private shippingmethodService: ShippingmethodService,
        private sharedTemplateService: SharedTemplateService,
        private salesOrderService: SalesOrderService,
        private utilityService: UtilityService,
        private timeZoneService: TimeZoneService,
        private currencyService: CurrencyService
    ) {
        this.currencySymbol = this.currencyService.currencySymbolValue;
    }

    ngOnInit(): void {
        this.initFieldForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['selectedActionField'] && changes['selectedActionField']?.currentValue){
            this.selectedActionField = changes['selectedActionField']?.currentValue;
        }

        if (changes['selectedParentModule'] && changes['selectedParentModule']?.currentValue) {
            this.selectedParentModule = changes['selectedParentModule']?.currentValue;
        }

        if(changes['addedFields'] && changes['addedFields']?.currentValue){
            this.addedFields = changes['addedFields']?.currentValue;

            if(this.currentColList?.length>0){
                this.generateAvailableFields('subModules');
            }
        }

        if (changes['selectedActionModule'] && changes['selectedActionModule']?.currentValue) {
            this.selectedActionModule = changes['selectedActionModule']?.currentValue;
            this.selectModuleAndChannel();
        }

        if (changes['selectedParentTemplate'] && changes['selectedParentTemplate']?.currentValue) {
            this.selectedParentTemplate = changes['selectedParentTemplate']?.currentValue;
            this.selectModuleAndChannel();
        }

        if (changes['displayAddField'] && changes['displayAddField']?.currentValue) {
            this.displayAddField = changes['displayAddField']?.currentValue;
            this.loadInitialData();
        }

    }

    selectModuleAndChannel(){
        if(this.selectedActionModule?.objectId && this.selectedActionModule?.objectId!=this.selectedParentModule?.objectId){
            this.selectedModule = ParseHelper.DeepCopy(this.selectedActionModule);
            this.selectedChannelId = this.selectedActionModule.channelId;
        }else{
            this.selectedModule = ParseHelper.DeepCopy(this.selectedParentModule);
            this.selectedChannelId = this.selectedParentTemplate?.id||0;
        }
    }

    loadInitialData(){
        if(this.selectedModule?.objectId && this.selectedChannelId){
            this.fieldAddEditHeader = `Add ${this.selectedModule.name} Update Field`;
            if([SOModuleId,InvoiceOrderModuleId,EstimateOrderModuleId].includes(this.selectedModule?.objectId)){
                this.loadOrderConfiguration();
                
            }else if([ProductModuleId].includes(this.selectedModule?.objectId)){
                this.loadProductConfiguration();
            }else if([VendorModuleId, PurchaseOrderModuleId].includes(this.selectedModule?.objectId)){
                this.loadVendorConfiguration();
            }  else{
                this.getTemplateFields();
            }
        }
    }

    getTemplateFields(){
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedTemplateService.getTemplateSectionsForFormBuild(this.selectedModule?.objectId, this.selectedChannelId).subscribe(
        {
            next: (response) => {
                this.currentColList = response || [];
                this.currentColList.map((fields, i)=>[
                    fields.customFields.map((customFields, i)=>{
                        const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                        customFields = {
                            ...customFields,
                            formControl: formControlDetails?.type,
                            formControlDetails: formControlDetails,
                            isCustom: true
                        }

                        fields.customFields[i] = customFields;
                    })
                ]);
                this.generateAvailableFields('subModules');
                if(this.selectedActionField){
                    this.setFieldEditData(this.selectedActionField);
                }
                this.appMainService.isHideSpinner('getColumnSettings');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getColumnSettings');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
    }

    generateAvailableFields(type: string){
        this.availableFields = [];
        if(![SOModuleId].includes(this.selectedModule?.objectId) ){
            this.availableFieldsForExpression = [...WorkflowCurrentDateFields];
        }
        this.currentColList.map(sectionDetails=>{
            if(!sectionDetails?.systemGenerated || sectionDetails.name.toLowerCase().includes('information') || (sectionDetails.name.toLowerCase().includes('details') && !sectionDetails.name.toLowerCase().includes('address'))){
                sectionDetails.fields.filter(f=> !this.hiddenChildFields.includes(f.field)).map(field=>{
                    if(field?.childFields?.length>0){
                        field.childFields.map(childField=>{
                            this.setFieldDetails(childField, type, this.selectedModule);
                        })
                    }else{
                        this.setFieldDetails(field, type, this.selectedModule);
                    }
                });

                sectionDetails.customFields.map(field=>{
                    this.setFieldDetails(field, type, this.selectedModule);
                });
            }
        });
    }

    setFieldDetails(fieldDetails: LeadAccountUpdateFieldsModel, type: string, selectedModule: any){
        if(fieldDetails?.field && fieldDetails?.mapObject!='opportunityProduct' && !this.hiddenFields.includes(fieldDetails.field) &&
            ![FormControlList.FileUpload,FormControlList.Picture,FormControlList.EncryptedText,FormControlList.AutoNumber,FormControlList.Formula].includes(fieldDetails.formControl)
        ){
            const alwaysRequiredFields = ['stagename','currentstage','classificationame'];
            const isRequried: boolean = (alwaysRequiredFields.includes(fieldDetails.field.toLowerCase()) || (fieldDetails?.isRequired||fieldDetails?.IsRequired||false));
            const field: any = {
                id: fieldDetails.id,
                labelname: this.getFormatedName(fieldDetails),
                name: fieldDetails.name,
                objectId: selectedModule?.objectId,
                objectName: selectedModule?.name,
                code: fieldDetails.field,
                isrequired: isRequried,
                ischecked: true,
                isShowInSetting: true,
                isDuplicate: true,
                isGlobalSearch: true,
                width: "",
                movable: false,
                showForDrag: false,
                templateId: this.selectedChannelId||0,
                sectionId: 0,
                custom: fieldDetails.isCustom,
                formControlId: fieldDetails?.formControlDetails?.id||FormControlListIds[fieldDetails.formControl],
                formControl: fieldDetails.formControl,
                expression: fieldDetails?.formControlDetails?.expression,
                pickListValues: fieldDetails?.formControlDetails?.pickListValues||[],
                maxLengthAfterDecimal: fieldDetails?.formControlDetails?.maxLengthAfterDecimal||null,
                field: fieldDetails.field,
                mapObject: "",
                isColumnSetting: true,
                value: "",
                displayOrder: 0,
                fieldTypes: null,
                fieldDataType: "String",
                valueDataType: "String",
                operators: [],
                operatorsDD: [],
                currencySymbol: fieldDetails?.currencySymbol
            }

            if(type !== 'parentModules' && (!this.addedFields.includes(field.field) || [CUSTOMFIELD_TYPE_IDS.MULTISELECT,CUSTOMFIELD_TYPE_IDS.CHECKBOX].includes(field?.formControlId))){
                this.availableFields.push(field);
            }

            if([FormControlList.Number,FormControlList.Decimal,FormControlList.Percentage].includes(fieldDetails.formControl)){               
                this.availableFieldsForExpression.push(field);
            }
        }
    }

    getFormatedName(fieldDetails: LeadAccountUpdateFieldsModel){
        let labelName = fieldDetails.labelName;

        if(fieldDetails.mapObject=='leadSocial'){
            labelName = `Lead ${fieldDetails.labelName}`
        }

        if(fieldDetails.mapObject=='accountSocial'){
            labelName = `Account ${fieldDetails.labelName}`
        }

        return labelName;
    }

    //#region ***Inventory Templates***

    loadOrderConfiguration(){
        let templateId = 0;
        switch (this.selectedModule?.objectId) {
            case SOModuleId:
                templateId = 3;
                break;
            case InvoiceOrderModuleId:
                templateId = 4;
                break;
            case EstimateOrderModuleId:
                templateId = 2;
                break;
            default:
                break;
        }

        this.appMainService.isShowSpinner("loadAllTemplates");
        this.salesOrderService
            .getAllOrdersChannel("Orders Template")
            .subscribe({
                next: (configs) => {
                    this.orderTemplates = JSON.parse(
                        configs.configurationDetails[0].configJSONValue
                    );
                    this.salesOrderTemplates = this.orderTemplates.find((t) => t.typeId == templateId);
                    if(this.salesOrderTemplates){
                        this.generateCheckFields();
                        this.getAllCustomAttributes();
                    }
                    this.appMainService.isHideSpinner("loadAllTemplates");
                },
                error: (error)=>{
                    this.appMainService.isHideSpinner("loadAllTemplates");
                },
                complete: () => {
                            this.generateAvailableFieldsForExpressionFromParentModules();
                }
            });
    }

    generateCheckFields(){
        const checkFields = {};
        this.availableFields = [];
        this.currentColList = [
            {
                id: 1,
                isToogle: false,
                name: "Inventory Details",
                fields: [],
                customFields: [],
                systemGenerated: true
            }
        ];
        WF_SO_UPDATE_FIELDS.map((section, sectionInex)=>{
            section.fields.filter(f=> !(f.formFieldname=='status' && this.selectedModule?.objectId==SOModuleId)).map(fieldDetails=>{
                const checkfield = this.salesOrderTemplates[section.sectionCode].find(field=> field.code==fieldDetails.settingFieldName || field?.name?.toLowerCase()==fieldDetails.settingFieldName);

                if(checkfield?.code=='freeshipping'){
                    checkfield.formControlId = FormControlListIds.ToggleButton;
                }

                if(checkfield?.code=='duedate'){
                    checkfield.formControlId = FormControlListIds.DatePicker;
                }
                if(checkfield?.code=='shipping'){
                    checkfield.formControlId = FormControlListIds.Decimal;
                }

                checkFields[fieldDetails.formFieldname] = checkfield ?
                    {
                        ...checkfield,
                        code: fieldDetails.settingFieldName,
                        field: fieldDetails.settingFieldName,
                        isCustom: false,
                        labelName: checkfield?.labelname||checkfield.name,
                        formFieldname: fieldDetails.formFieldname,
                        formControl: getFormControlNameById(checkfield?.formControlId)
                    } :{};

                if(checkfield?.isChecked){
                    this.setFieldDetails(checkFields[fieldDetails.formFieldname], 'subModules', this.selectedModule);
                    this.currentColList[0].fields.push(checkFields[fieldDetails.formFieldname]);
                }
            })
        });
    }

    getAllCustomAttributes() {
        this.appMainService.isShowSpinner("loadCustomAttributes");
        this.productsService
            .getAllCustomFields(this.orderObjId)
            .then((fields) => {
                this.orderCustomAttributes = _.cloneDeep(fields);
                this.setCustomAttributes();
                if(this.selectedActionField){
                    this.setFieldEditData(this.selectedActionField);
                }
                this.appMainService.isHideSpinner("loadCustomAttributes");
            }).catch(error=>{
                this.appMainService.isHideSpinner("loadCustomAttributes");
            });
    }

    setCustomAttributes(){
        if(this.orderCustomAttributes && this.salesOrderTemplates){
            const salesOrderTemplates = ParseHelper.DeepCopy(this.salesOrderTemplates);
            this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(salesOrderTemplates, this.orderCustomAttributes);
            this.generateCustomAttributeFields();
        }
    }

    generateCustomAttributeFields(){
        if(this.combinedCustomFields){
            const implementedSections = ['footer_item','billing_address_item','shipping_address_item','section_item','misc_item','message_item'];
            Object.keys(this.combinedCustomFields).filter(key=> implementedSections.includes(key)).map(key=>{
                const fields = this.combinedCustomFields[key].filter(f=> f.isChecked);
                fields.map(customField=>{
                    let pickListValues: any[] = customField?.pickListValues||[];
                    const fieldDetails = {
                        ...customField,
                        code: customField.code,
                        field: customField.code,
                        isCustom: true,
                        labelName: customField.name,
                        formControl: getFormControlNameById(customField?.formControlId),
                        formControlDetails: {
                            pickListValues: pickListValues
                        }
                    }

                    this.setFieldDetails(fieldDetails, 'subModules', this.selectedModule);
                    this.currentColList[0].customFields.push(fieldDetails);
                })

           });
        }
    }

    loadProductConfiguration(){
        this.appMainService.isShowSpinner('productFields');
        this.productsService.getProductConfigurations('product').subscribe(config => {
            this.appMainService.isHideSpinner('productFields');
            //Product Templates
            const productTemplates = config.filter(config => (config.name == 'Product Template' && config.categoryId == 6))[0];
            const templates = JSON.parse(productTemplates.configurationDetails[0].configJSONValue);
            const productTemplate = templates.find((t) => t.producttypeId == this.selectedChannelId);
            this.generateProductCheckFields(productTemplate);
        }, (error)=>{
            this.appMainService.isHideSpinner('productFields');
        });
    }

    generateProductCheckFields(productTemplate: any){
        const checkFields = {};
        this.availableFields = [];
        this.currentColList = [
            {
                id: 1,
                isToogle: false,
                name: "Product Details",
                fields: [],
                customFields: [],
                systemGenerated: true
            }
        ];

        let updateFields: any[] = [];

        switch(this.selectedChannelId){
            case this.productTypeIds.InventoryTypeId:
                updateFields = WF_IN_PRODUCT_UPDATE_FIELDS;
                break;
            case this.productTypeIds.NonInventoryTypeId:
                updateFields = WF_NON_PRODUCT_UPDATE_FIELDS;
                break;
            case this.productTypeIds.ServiceTypeId:
                updateFields = WF_SERVICE_PRODUCT_UPDATE_FIELDS;
                break;
            case this.productTypeIds.BundleTypeId:
                updateFields = WF_BUNDLE_PRODUCT_UPDATE_FIELDS;
                break;
            case this.productTypeIds.KitTypeId:
                updateFields = WF_KIT_PRODUCT_UPDATE_FIELDS;
                break;
        }

        updateFields.map((section, sectionInex)=>{
            section.fields.map(fieldDetails=>{
                const checkfield = productTemplate[section.sectionCode].find(field=> field.code==fieldDetails.settingFieldName || field?.name?.toLowerCase()==fieldDetails.settingFieldName);

                if(['uom','category'].includes(checkfield?.code)){
                    checkfield.formControlId = FormControlListIds.MultipleDropDownList;
                }

                checkFields[fieldDetails.formFieldname] = checkfield ?
                    {
                        ...checkfield,
                        code: fieldDetails.settingFieldName,
                        field: fieldDetails.settingFieldName,
                        isCustom: false,
                        labelName: checkfield?.labelname||checkfield.name,
                        formFieldname: fieldDetails.formFieldname,
                        formControl: getFormControlNameById(checkfield?.formControlId)
                    } :{};

                if(checkfield?.isChecked){
                    this.setFieldDetails(checkFields[fieldDetails.formFieldname], 'subModules', this.selectedModule);
                    this.currentColList[0].fields.push(checkFields[fieldDetails.formFieldname]);
                }
            })
        });

        this.generateProductCustomFields(updateFields, productTemplate);
    }

    generateProductCustomFields(updateFields: any[], productTemplate: any){
        this.appMainService.isShowSpinner('productCustomFields');
        this.productsService.getAllCustomFields(this.selectedModule?.objectId).then((fields) => {
            if(fields && fields.length>0){
                fields.map(customField=>{
                    const checkUpdateSectionCode = updateFields.find(uf=> uf?.sectionCode==customField?.section?.code);
                    if(checkUpdateSectionCode && productTemplate?.[customField?.section?.code]){
                        const fieldEnabled = productTemplate[customField.section.code].find(
                            (el) =>
                                el.code == customField.name &&
                                el.sectionId == customField.section.id
                        );

                        if(fieldEnabled?.isChecked){
                            let pickListValues: any[] = customField?.pickListValues||[];
                            const fieldDetails = {
                                ...customField,
                                code: customField.name,
                                field: customField.name,
                                isCustom: true,
                                labelName: fieldEnabled?.labelname||customField.name,
                                formControl: getFormControlNameById(customField?.formControlId),
                                formControlDetails: {
                                    pickListValues: pickListValues
                                }
                            }

                            this.setFieldDetails(fieldDetails, 'subModules', this.selectedModule);
                            this.currentColList[0].customFields.push(fieldDetails);
                        }
                    }
                });
            }

            if(this.selectedActionField){
                this.setFieldEditData(this.selectedActionField);
            }

            this.appMainService.isHideSpinner('productCustomFields');
        }).catch((error)=>{
            this.appMainService.isHideSpinner('productCustomFields');
        });
    }

    // loadVendorConfiguration(){
    //     this.appMainService.isShowSpinner('vendorFields');
    //     this.purchaseService.getPOConfigurations('Purchase').subscribe(config => {
    //         this.appMainService.isHideSpinner('vendorFields');
    //         //Product Templates
    //         const vendorTemplates = config.filter(config => (config.name == 'Purchase Template'))[0];
    //         const templates = JSON.parse(vendorTemplates.configurationDetails[0].configJSONValue);
    //         const vendorTemplate = templates.find((t) => t.templateName == 'Vendors_template');
            
    //         this.generateVendorCheckFields(vendorTemplate);
    //     }, (error)=>{
    //         this.appMainService.isHideSpinner('vendorFields');
    //     });
    // }

    loadVendorConfiguration() {
        let productTypeId: number;
        switch (this.selectedModule?.objectId) {
            case VendorModuleId:
                productTypeId = 5;
                this.getVendorSelectedTemplateDetails(productTypeId);
                break;

            case PurchaseOrderModuleId:
                productTypeId = 1;
                this.getVendorSelectedTemplateDetails(productTypeId);

        }

    }

    getVendorSelectedTemplateDetails(productTypeId: number) {
        this.appMainService.isShowSpinner('vendorFields');

        this.purchaseService.getPOConfigurations('Purchase').subscribe({
            next: (configs) => {
                this.appMainService.isHideSpinner('vendorFields');
                const purchaseTemplate = configs.filter(config => config.name == 'Purchase Template')[0];
                const vendorTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
                const vendorTemplate = vendorTemplates.find((t) => t.producttypeId == productTypeId);
                this.generateVendorCheckFields(vendorTemplate, productTypeId);
            },
            error: (error) => {
                this.appMainService.isHideSpinner('vendorFields');
                // Optional: handle error
            }
        });

    }
    

    generateVendorCheckFields(vendorTemplate: any, productTypeId: number){
        const checkFields = {};
        this.availableFields = [];
        this.currentColList = [
            {
                id: 1,
                isToogle: false,
                name: "Vendor Details",
                fields: [],
                customFields: [],
                systemGenerated: true
            }
        ];

        let updateFields: any[] = [];

        switch (productTypeId) {
            case 1:
                updateFields = WF_PO_FORM_FIELDS;
                break;
            case 5:
                updateFields = WF_VENDOR_UPDATE_FIELDS;
                break;
            default:
                updateFields = []; // fallback
        }

        updateFields.map((section, sectionInex)=>{
            section.fields.map(fieldDetails=>{
                const checkfield = vendorTemplate[section.sectionCode].find(field=> field.code==fieldDetails.settingFieldName || field?.name?.toLowerCase()==fieldDetails.settingFieldName);

                if(['vendorstype','ddPaymentMethod','ddPaymentTerm','txtShipMethod'].includes(checkfield?.code)){
                    checkfield.formControlId = FormControlListIds.MultipleDropDownList;
                }

                checkFields[fieldDetails.formFieldname] = checkfield ?
                    {
                        ...checkfield,
                        code: fieldDetails.settingFieldName,
                        field: fieldDetails.settingFieldName,
                        isCustom: false,
                        labelName: checkfield?.labelname||checkfield.name,
                        formFieldname: fieldDetails.formFieldname,
                        formControl: getFormControlNameById(checkfield?.formControlId)
                    } :{};

                if(checkfield?.isChecked){
                    this.setFieldDetails(checkFields[fieldDetails.formFieldname], 'subModules', this.selectedModule);
                    this.currentColList[0].fields.push(checkFields[fieldDetails.formFieldname]);
                }
            })
        });

        this.generateVendorCustomFields(updateFields, vendorTemplate);
    }

    generateVendorCustomFields(updateFields: any[], productTemplate: any){
        this.appMainService.isShowSpinner('vendorCustomFields');
        const purchaseObjId = this.app.preLoadedObjects.find(
            (el) => el.name == ObjectNames.purchaseConstants.Purchase_Module_Object)?.id;
        this.productsService.getAllCustomFields(purchaseObjId).then((fields) => {
            if(fields && fields.length>0){
                fields.map(customField=>{
                    const checkUpdateSectionCode = updateFields.find(uf=> uf?.sectionCode==customField?.section?.code);
                    if(checkUpdateSectionCode && productTemplate?.[customField?.section?.code]){
                        const fieldEnabled = productTemplate[customField.section.code].find(
                            (el) =>
                                el.code == customField.name &&
                                el.sectionId == customField.section.id
                        );

                        if(fieldEnabled?.isChecked){
                            let pickListValues: any[] = customField?.pickListValues||[];
                            const fieldDetails = {
                                ...customField,
                                code: customField.name,
                                field: customField.name,
                                isCustom: true,
                                labelName: fieldEnabled?.labelname||customField.name,
                                formControl: getFormControlNameById(customField?.formControlId),
                                formControlDetails: {
                                    pickListValues: pickListValues
                                }
                            }

                            this.setFieldDetails(fieldDetails, 'subModules', this.selectedModule);
                            this.currentColList[0].customFields.push(fieldDetails);
                        }
                    }
                });
            }

            if(this.selectedActionField){
                this.setFieldEditData(this.selectedActionField);
            }

            this.appMainService.isHideSpinner('vendorCustomFields');
        }).catch((error)=>{
            this.appMainService.isHideSpinner('vendorCustomFields');
        });
    }

    //#endregion

    saveField(){
        if (this.fieldDetailsForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        const selectedField: SavedSearchNS.IField = this.fieldDetailsForm.getRawValue().selectedField;
        let fieldValue: any = this.setEmptyValue(selectedField);

        if(fieldValue!==null && fieldValue!=="" && !['String','Date','DateTime'].includes(this.fieldDetailsForm.value?.fieldDataType)){
            if(this.multiTreeSelectFields.includes(this.fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase())){
                const formatedValue = [];
                fieldValue?.map(value=>{
                    formatedValue.push({
                        id: value?.id||value?.value?.id||null,
                        name: value.label
                    })
                });

                fieldValue = JSON.stringify(formatedValue);
            }else if(this.treeSelectFields.includes(this.fieldDetailsForm.getRawValue().selectedField?.field?.toLowerCase())){
                fieldValue = fieldValue ? JSON.stringify({
                    id: fieldValue?.id||fieldValue?.value?.id||null,
                    name: fieldValue.label
                }) : null;
            }else{
                fieldValue = JSON.stringify(fieldValue);
            }
        }

        if(this.fieldDetailsForm.value?.fieldDataType=='Date' && fieldValue){
            const date: Date = fieldValue;
            fieldValue = date.toLocaleDateString();
            // if(['expectedDate'].includes(selectedField.field)){
            //     fieldValue = this.app._saveDateTimeWithZone(new Date(date.setHours(23,59,59))).toISOString();
            // }else{
            //     fieldValue = date.toLocaleDateString();
            // }
        }else if(this.fieldDetailsForm.value?.fieldDataType=='DateTime' && fieldValue){
            fieldValue = this.timeZoneService._getCustomDateTimeString(fieldValue);
        }

        const fieldData: WorkflowModelsNS.WorkflowAddEditActionUpdateFields = {
            id: this.fieldDetailsForm.getRawValue().id,
            statusId: this.selectedActionField?.statusId||1,
            workflowActionId: this.selectedActionField?.workflowActionId||0,
            objectId: this.selectedModule?.objectId,
            objectName: this.selectedModule.name,
            fieldName: selectedField.field,
            labelName: selectedField.labelname,
            isCustom: selectedField.custom,
            formControlId: selectedField.formControlId,
            maxLengthAfterDecimal: selectedField?.maxLengthAfterDecimal||null,
            operationType: this.fieldDetailsForm.value?.operationType||WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update,
            fieldDataType: this.fieldDetailsForm.value?.fieldDataType||'String',
            fieldValueType: this.fieldDetailsForm.value?.fieldValueType||WorkflowModelsNS.WorkflowUpdateFieldValueType.Value,
            fieldValue: fieldValue,
            workflowUpdateFieldExpressionFields: [],
            currencySymbol: selectedField.currencySymbol ?? null
        }

        if(fieldData.fieldValueType==WorkflowModelsNS.WorkflowUpdateFieldValueType.Expression){
            this.updatedAddedTags(fieldData.fieldValue);

            this.addedFieldTags.map((labelName, index )=>{
                const exist = this.availableFieldsForExpression.find(field=>field.labelname==labelName);
                if(exist){
                    let id = 0;

                    if(this.selectedActionField){
                        const addedField = this.selectedActionField.workflowUpdateFieldExpressionFields.find(field=>field.fieldName==exist.field);
                        id = addedField ? addedField.id : 0;
                    }

                    fieldData.workflowUpdateFieldExpressionFields.push({
                        id: id,
                        workflowActionUpdateFieldId: this.selectedActionField?.id||0,
                        fieldName: exist.field,
                        labelName: exist.labelname.trim(),
                        statusId: 1,
                        isCustom: exist.custom,
                        objectId: exist.objectId,
                        objectName: exist.objectName,
                        displayOrder: index,
                       
                    })
                }
            })
        }

        //Set removed fields
        if(this.selectedActionField){
            this.selectedActionField.workflowUpdateFieldExpressionFields.map(previousField=>{
                const exist = fieldData.workflowUpdateFieldExpressionFields.find(field=>field.fieldName==previousField.fieldName);
                if(!exist){
                    fieldData.workflowUpdateFieldExpressionFields.push({
                        ...previousField,
                        statusId: 3
                    })
                }
            })
        }

        this.fieldSaved.emit(fieldData);
        this.dialogClose();
    }

    setEmptyValue(selectedField: SavedSearchNS.IField){
        let fieldValue: any = this.fieldDetailsForm.getRawValue().newValue;

        if(fieldValue!==0 && !fieldValue){
            if ([this.customFieldIds.DATE_PICKER, this.customFieldIds.DATETIMEPICKER, this.customFieldIds.MULTISELECT, this.customFieldIds.CHECKBOX, this.customFieldIds.FILE,
                this.customFieldIds.PICTURE].includes(selectedField.formControlId)) {
                fieldValue = "";
            }else if ([this.customFieldIds.DROPDOWN, this.customFieldIds.RATING, this.customFieldIds.RADIO_BUTTON, this.customFieldIds.NUMBER,this.customFieldIds.DECIMAL].includes(selectedField.formControlId)) {
                fieldValue = null;
            }
        }

        if(fieldValue===0 && selectedField.formControlId==this.customFieldIds.RATING){
            fieldValue = null;
        }

        if(([this.customFieldIds.MULTISELECT, this.customFieldIds.CHECKBOX].includes(selectedField.formControlId) && fieldValue?.length==0)){
            fieldValue = "";
        }

        return fieldValue;
    }

    setFieldEditData(selectedActionField: WorkflowModelsNS.WorkflowAddEditActionUpdateFields){
        this.fieldAddEditHeader = this.viewOnly ? `View ${this.selectedModule.name} Update Field` : `Edit ${this.selectedModule.name} Update Field`;
        if(this.currentColList?.length>0){
            this.generateAvailableFields('subModules');
        }
        const selectedField = this.availableFields.find(field=> field.field===selectedActionField.fieldName)||null;
        let addedValue: any = selectedActionField.fieldValue;

        if(selectedActionField.fieldDataType=='Date' && selectedActionField.fieldValue){
            addedValue = new Date(selectedActionField.fieldValue);
        }else if(selectedActionField.fieldDataType=='DateTime' && selectedActionField.fieldValue){
            addedValue = selectedActionField.fieldValue? this.timeZoneService.showDateTimeWithZone(selectedActionField.fieldValue) : ''; new Date(selectedActionField.fieldValue);
        }else if (selectedActionField.fieldDataType!='String'){
            addedValue = selectedActionField.fieldValue ? JSON.parse(selectedActionField.fieldValue) : selectedActionField.fieldValue;
        }

        this.fieldDetailsForm.patchValue({
            id: selectedActionField.id,
            selectedField: selectedField,
            newValue: addedValue,
            fieldDataType: selectedActionField.fieldDataType,
            fieldValueType: selectedActionField?.fieldValueType||WorkflowModelsNS.WorkflowUpdateFieldValueType.Value,
            operationType: selectedActionField?.operationType||WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update
        });

        const newValueControl = this.fieldDetailsForm.get('newValue');
        const validations = [];

        if(selectedField?.isrequired){
            validations.push(Validators.required);
        }

        if(selectedField?.expression && ![this.customFieldIds.DATETIMEPICKER, this.customFieldIds.DECIMAL, this.customFieldIds.NUMBER].includes(selectedField?.formControlId)){
            validations.push(Validators.pattern(selectedField?.expression));
        }

        newValueControl.setValidators(validations);
        newValueControl.updateValueAndValidity();

        if(this.viewOnly){
            this.fieldDetailsForm.disable();
        }

        this.getFieldChangeValue(addedValue);
    }

    initFieldForm(){
        this.fieldAddEditHeader = 'Add Update Field';
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.fieldDetailsForm = this.formBuilder.group({
            id: [0],
            selectedField: ["", [Validators.required]],
            operationType: [WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update],
            fieldDataType: ["String"],
            fieldValueType: [WorkflowModelsNS.WorkflowUpdateFieldValueType.Value],
            newValue: ["", [Validators.required]],
        });

        this.formErrorHandler.handleErrors(this.fieldDetailsForm, this.detailsFormErrors, {
            name: {
                required: "Enter Name",
            },
            selectedField: {
                required: "Select Field",
            },
            newValue: {
                required: "Enter new value"
            }
        });
    }

    selectField(){
        this.setSectionCustomPayload();
        this.getFieldChangeValue(null);
    }

    setSectionCustomPayload() {
        const selectedField: SavedSearchNS.IField = this.fieldDetailsForm.getRawValue().selectedField;

        if(selectedField.formControlId){

            const formControlId: number = selectedField.formControlId;
            let newValue: any = "";
            let dataType: string = "String";

            if (formControlId === this.customFieldIds.CHECKBOX) {
                newValue = [];
                dataType = 'Array';
            } else if (formControlId === this.customFieldIds.TOOGLE_BUTTON) {
                newValue = false;
                dataType = 'Boolean';
            } else if (formControlId === this.customFieldIds.DATE_PICKER) {
                newValue = null;
                dataType = 'Date';
            } else if (formControlId === this.customFieldIds.DATETIMEPICKER) {
                newValue = null;
                dataType = 'DateTime';
            } else if (formControlId === this.customFieldIds.DROPDOWN || formControlId === this.customFieldIds.USERLOOKUP) {
                newValue = null;
                dataType = 'Object';
            } else if (formControlId === this.customFieldIds.MULTISELECT) {
                newValue = null;
                dataType = 'Array';
            } else if (formControlId === this.customFieldIds.RATING) {
                newValue = 0;
                dataType = 'Number';
            } else if (formControlId === this.customFieldIds.FILE || formControlId === this.customFieldIds.PICTURE) {
                newValue = null;
                dataType = 'File';
            } else if (formControlId === this.customFieldIds.INPUT) {
                newValue = "";
                dataType = 'String';
            } else if (formControlId === this.customFieldIds.NUMBER || formControlId === this.customFieldIds.DECIMAL) {
                newValue = null;
                dataType = 'Number';
            } else if (formControlId === this.customFieldIds.RADIO_BUTTON) {
                newValue = null;
                dataType = 'String';
            }else {
                newValue = null;
                dataType = 'String';
            }

            this.fieldDetailsForm.patchValue({
                newValue: newValue,
                fieldDataType: dataType,
                operationType: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update
            });

            const newValueControl = this.fieldDetailsForm.get('newValue');
            const validations = [];

            if(selectedField?.isrequired){
                validations.push(Validators.required);
            }

            if(selectedField?.expression && ![this.customFieldIds.DATETIMEPICKER, this.customFieldIds.DECIMAL, this.customFieldIds.NUMBER].includes(formControlId)){
                validations.push(Validators.pattern(selectedField?.expression));
            }

            newValueControl.setValidators(validations);
            newValueControl.updateValueAndValidity();
        }
    }

    getFieldChangeValue(selectedValues: any) {
        // console.log(field)
        //****Custom Field */
        const field: SavedSearchNS.IField = this.fieldDetailsForm.getRawValue().selectedField;
        if (field.custom == true) {
            if (
                // field.fieldDataType == 'Enum' ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.MULTISELECT ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.DROPDOWN ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.CHECKBOX ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.RADIO_BUTTON) {
                let custompickvalues = [];
                let typescustom = [];
                typescustom = ParseHelper.DeepCopy((field?.pickListValues||[]));
                for (let name of typescustom) {
                    let eachType = {
                        name: name
                    }
                    if(typeof name=='object'){
                        eachType = name;
                    }
                    custompickvalues.push(eachType);
                }
                this.dropdownValues = custompickvalues;
            }else if (field?.formControlId == CUSTOMFIELD_TYPE_IDS.USERLOOKUP) {
                this.getUsersList(selectedValues);
            }else if (field?.formControlId == CUSTOMFIELD_TYPE_IDS.RATING) {
                let custompickvalues = RatingValueObjects;
                this.dropdownValues = custompickvalues;
            }
        }
        else {
            this.dropdownValues = [];
            if (['salesrep','owner','ownername','currentstageowner'].includes(field.field?.toLowerCase())) {
                this.getUsersList(selectedValues);
            } else if (field.field?.toLowerCase() == "accounttypesname") {
                this.getAllAccountTypes(selectedValues);
            } else if (field.field?.toLowerCase() == "sourcename") {
                if (this.selectedModule.name.toLowerCase() == SavedSearchParentModule.Lead?.toLowerCase()) {
                    this.getAllLeadSource(selectedValues);
                }
                else if (this.selectedModule.name.toLowerCase() == SavedSearchParentModule.Account?.toLowerCase()) {
                    this.getAllAccountSource(selectedValues);
                }
                else if (this.selectedModule.name.toLowerCase() == SavedSearchParentModule.Opportunity?.toLowerCase()) {
                    this.getOpportunitySources(selectedValues);
                }
            } else if (['ddemployees','noofemployees','employeesrangename'].includes(field.field?.toLowerCase())) {
                this.getAllEmployeesCount(selectedValues);
            } else if (['ddannualrevenue','estimatedannualrevenue','annualrevenuename'].includes(field.field?.toLowerCase())) {
                this.getAllAnnualRevenue(selectedValues);
            } else if (['dbownership','ownershiptype','ownershipname'].includes(field.field?.toLowerCase())) {
                this.getAllOwners(selectedValues);
            } else if (['stagename','currentstage','classificationame'].includes(field.field?.toLowerCase())) {
                this.getAllStages(selectedValues, this.selectedModule?.objectId, this.selectedChannelId);
            } else if (['timezone','timezonename'].includes(field.field?.toLowerCase())) {
                this.getAllTimezones(selectedValues);
            } else if (['ddindustry','industryname','industry'].includes(field.field?.toLowerCase())) {
                this.getAllIndustries(selectedValues);
            } else if (['ddlanguage','languagespoken'].includes(field.field?.toLowerCase())) {
                this.getLanguageList(selectedValues);
            } else if (['ddgender','trans_sales_rep_gender','trans_created_by_gender','gender'].includes(field.field?.toLowerCase())) {
                this.getGenders(selectedValues);
            } else if (field.field?.toLowerCase() == 'leadtypesname') {
                this.getAllLeadTypes(selectedValues);
            } else if (field.field?.toLowerCase() == "leadsstatus") {
                this.getAllLeadStatus(selectedValues);
            } else if (field.field?.toLowerCase() == 'tags') {
                this.getAllTags(selectedValues);
            } else if (['country','manufacturercountry'].includes(field.field?.toLowerCase())) {
                this.getCountryByTemplateId(selectedValues);
            } else if (field.field?.toLowerCase() == "state") {
                this.getStatesByCountry(selectedValues);
            } else if (field.field?.toLowerCase() == "city") {
                this.getCityByStateList(selectedValues);
            } else if (['currency','currencyname','currencyunitid'].includes(field.field?.toLowerCase())) {
                this.getCurrencyList(selectedValues);
            } else if (field.field?.toLowerCase() == "ratingname") {
                this.getAllRatings(selectedValues);
            } else if (['ddtitle','title'].includes(field.field?.toLowerCase())) {
                this.getSalutations(selectedValues);
            } else if (['ddjobfunction','jobfunction'].includes(field.field?.toLowerCase())) {
                this.getJobFunction(selectedValues);
            } else if (field.field?.toLowerCase() == "territoryname") {
                this.getAllCountryTerriList(selectedValues);
            }
            else if(['contact_roles'].includes(field.field?.toLowerCase())) {
                this.loadContactRoles(selectedValues);
            }
        
            //Estimate
            else if (field.field?.toLowerCase() == "warehouseid") {
                this.getAllWarehouse(selectedValues);
            } else if (['ddpaymentterm','paymenttermid','paymenttermname','paymentterm','preferredpaymentterm'].includes(field.field?.toLowerCase())) {
                this.getPaymentTermList(selectedValues);
            } 
            else if (['payment term'].includes(field.field?.toLowerCase())) {
                this.getVendorPaymentTermList(selectedValues);
            }else if (['ddpaymentmethod','paymentmethodid','paymentmethod','preferredpaymentmethod'].includes(field.field?.toLowerCase())) {
                this.getPaymentMrthodList(selectedValues);
            } 
            else if (['payment method'].includes(field.field?.toLowerCase())) {
                this.getVendorPaymentMrthodList(selectedValues);
            }
            else if (field.field?.toLowerCase() == "shippingtermid" || field.field?.toLowerCase() == "shippingterm") {
                this.getShippingTermList(selectedValues);
            } else if (['shippingmethodid','shippingmethod','preferredshippingmethod'].includes(field.field?.toLowerCase())) {
                this.getShippingMethodList(selectedValues);
            } else if (['txtshipmethod'].includes(field.field?.toLowerCase())) {
                this.getShippingMethodFlatList(selectedValues);
            }  else if (field.field?.toLowerCase() == "discounttypeid") {
                this.getInventoryGroup('discount', selectedValues);
            } else if (['color'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('color', selectedValues);
            } else if (['warranty'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('warranty', selectedValues);
            } else if (field.field?.toLowerCase() == "taxtypeid" || field.field?.toLowerCase() == "taxid") {
                this.getInventoryGroup('tax', selectedValues);
            } else if (['vendorstype','ddbusiness'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup(field.field?.toLowerCase(), selectedValues);
            } else if (field.field?.toLowerCase() == "accountid") {
                // this.getAccountList(rule, editedRule);
            } else if (field.field?.toLowerCase() == "item" || field.field?.toLowerCase() == "productname") {
                this.getProductMinified(selectedValues);
            } else if (field.field?.toLowerCase() == "status") {
                if(this.selectedModule?.objectId==EstimateOrderModuleId){
                    this.getEstimateStatus(selectedValues);
                }else if(this.selectedModule?.objectId==InvoiceOrderModuleId){
                    this.getInvoiceStatus(selectedValues);
                }
            } else if (field.field?.toLowerCase() == "estimatestatusid") {
                this.getEstimateStatus(selectedValues);
            } else if (field.field?.toLowerCase() == "orderstatusid" || field.name?.toLowerCase() == "order status") {
                this.getOrderStatus(selectedValues);
            } else if (field.field?.toLowerCase() == "paymentstatusid" || field.name?.toLowerCase() == "payment status") {
                this.getPaymentStatus(selectedValues);
            } else if (field.field?.toLowerCase() == "shipmentstatusid" || field.name?.toLowerCase() == "shipment status") {
                this.getShipmentStatus(selectedValues);
            } else if (field.field?.toLowerCase() == "quality") {
                this.getOpportunityRatings(selectedValues);
            } else if (field.field?.toLowerCase() == "salesorderstatusid") {
                this.getSalesOrderStatus(selectedValues);
            } else if (field.field?.toLowerCase() == "salesorderstageid") {
                this.getSalesOrderStage(selectedValues);
            } else if (field.field?.toLowerCase() == "taxable") {
                this.getTaxablePreference(selectedValues);
            } else if (field.field?.toLowerCase() == "typeid") {
                this.getConfigData('type', 'product', selectedValues);
            } else if (['brandid','brand'].includes(field.field?.toLowerCase())) {
                this.getBrandList(selectedValues);
            } else if (['vendorid','vendor','preferrredvendor'].includes(field.field?.toLowerCase())) {
                this.getVendor('vendor', selectedValues);
            } else if (['manufacturerid','manufacturer'].includes(field.field?.toLowerCase())) {
                this.getVendor('manufacturer', selectedValues);
            } else if (field.field?.toLowerCase() == "variant") {
                this.getInventoryGroup('variant', selectedValues);
            } else if (['lwhunitofmeasurementid','lwhuom'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('height', selectedValues)
            } else if (['wunitofmeasuremetid','wuom'].includes(field.field?.toLowerCase())) {
                this.getInventoryGroup('weight', selectedValues)
            } else if (['assetaccountid','asset'].includes(field.field?.toLowerCase())) {
                this.loadAllFinancialAccounts('Assets', selectedValues);
            } else if (field.code?.toLowerCase() == 'cogs') {
                this.loadAllFinancialAccounts('Cost of Good Sold (COGS)', selectedValues);
            } else if (['incomeaccountid','incomeaccount','income'].includes(field.field?.toLowerCase())) {
                this.loadAllFinancialAccounts('Income', selectedValues);
            } else if (['expensecogs','expenseaccount'].includes(field.code?.toLowerCase())) {
                this.loadAllFinancialAccounts('Expenses', selectedValues);
            } else if (['classid','class'].includes(field.field?.toLowerCase())) {
                this.getAllClass(selectedValues);
            } else if (field.field?.toLowerCase() == 'category') {
                this.getInventoryGroup('category', selectedValues);
            } else if (field.field?.toLowerCase() == 'uom') {
                this.getUnitOfMeasures(selectedValues);
            } else if(['accountname'].includes(field.field?.toLowerCase())) {
                this.setParentSelectedAccount(selectedValues);
            } else if(['activeinactivestatus'].includes(field.field?.toLowerCase())){
                this.getActiveInActiveStatus(selectedValues);
            }
        }
    }

    //#region API Calls

    getUsersList(selectedValues: any){
        const dropdownValues = this.app.usersList.filter(obj => obj.statusId == 1);
        this.setDropDownValue(dropdownValues, selectedValues);
    }

    getCountryByTemplateId(selectedValues: any) {
        this.appMainService.isShowSpinner('LoadCountry');
        this.savedSearchesService.getAllCountryDto().subscribe(res => {
            this.appMainService.isHideSpinner('LoadCountry');
            let allCountries = [];
            if (res) {
                allCountries = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.dropdownValues = allCountries;
        },
            err => {
                this.appMainService.isHideSpinner('LoadCountry');
            });
    }

    getStatesByCountry(selectedValues: any) {
        let findCountrySelected = null;

        if (findCountrySelected?.value?.id) {
            this.appMainService.isShowSpinner('loadStates');
            this.savedSearchesService.getStateByMultipleCountryIdDto(findCountrySelected?.value?.id?.toString()).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(states => {
                this.appMainService.isHideSpinner('loadStates');
                let allStates = [];
                if (states) {
                    allStates = states.map(x => ({ id: x.id, name: x.name }));
                }
                this.setDropDownValue(allStates, selectedValues);
            },
                err => {
                    this.appMainService.isHideSpinner('loadStates');
                });
        }
    }

    getCityByStateList(selectedValues: any) {

    }

    mapToNewArrayCities(dataSet: any, id = 'id', mapField = 'name') {
        if (dataSet.length) {
            return dataSet.map(obj => ({
                id: Number(obj[id] + ""),
                name: obj[mapField],
                cities: obj.cities ? this.mapToNewArray(obj.cities) : []
            }))
        }
        return [];
    }
    mapToNewArray(dataSet: any, mapField = 'name') {
        if (dataSet.length) {
            return dataSet.map(obj => ({
                id: Number(obj.id + ""),
                name: obj[mapField],
                // count: obj?.count != null ? obj.count : null
            }))
        }
        return [];
    }
    findInArray(filterValArr: any, optionArr: any) {
        return optionArr.filter(obj => filterValArr.find(val => val.name == obj.name));
    }

    getAllLeadTypes(selectedValues: any) {
        this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).then(types => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    getAllLeadStatus(selectedValues: any) {
        this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(status => {
            let resValue = []
            if (status) {
                resValue = status.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }

    getActiveInActiveStatus(selectedValues: any) {
        let resValue = [
            {id: Status.Active, name: 'Active'},
            {id: Status.InActive, name: 'In Active'},
        ];

        this.setDropDownValue(resValue, selectedValues);
    }
    //Stage
    getAllStages(selectedValues: any, objectId: number, channelId: number) {
        this.ruleService.getStageList(objectId,channelId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(stages => {
            let resValue = []
            if (stages) {
                resValue = stages.filter(el => el.id && el.id !== -1).map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Industry
    getAllIndustries(selectedValues: any) {
        this.accountService.getAllIndustries().then(industries => {
            let resValue = []
            if (industries) {
                resValue = industries.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //AccountSource
    getAllAccountSource(selectedValues: any) {
        this.accountService.getAllSources(this.app.user.organizationId).then(source => {
            let resValue = []
            if (source) {
                resValue = source.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Owners
    getAllOwners(selectedValues: any) {
        this.accountService.getAllOwnerships().then(owners => {
            let resValue = []
            if (owners) {
                resValue = owners.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //LeadSource
    getAllLeadSource(selectedValues: any) {
        this.leadService.getAllSources(this.app.user.organizationId).then(source => {
            let resValue = []
            if (source) {
                resValue = source.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Currency
    getCurrencyList(selectedValues: any) {
        this.accountService.getCurrency().then(currencyList => {
            let resValue = []
            if (currencyList) {
                resValue = currencyList.map(x => ({ id: x.id, name: `${x.name} - ${x.code}` }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Language
    getLanguageList(selectedValues: any) {
        this.accountService.getLanguage().then(languageList => {
            let resValue = []
            if (languageList) {
                resValue = languageList.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Genders
    getGenders(selectedValues: any) {
        this.contactService.getAllGender().then(resp => {
            let resValue = resp.filter(el => el?.isActive === true) || [];
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Timezone
    getAllTimezones(selectedValues: any) {
        this.accountService.getTimezone().then(timezoneList => {
            let resValue = []
            if (timezoneList) {
                resValue = timezoneList.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //AnnualRevenue
    getAllAnnualRevenue(selectedValues: any) {
        this.accountService.getAllRevenues().then(revenue => {
            let resValue = []
            if (revenue) {
                resValue = revenue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Rating
    getAllRatings(selectedValues: any) {
        this.fieldService.getAllRatings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(ratings => {
            let resValue = ratings || [];
            if (ratings) {
                resValue = ratings.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //Salutation/Title
    getSalutations(selectedValues: any) {
        this.contactService.getSalutations().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
            let resValue = resp.filter(el => el?.isActive === true) || [];
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //EmployeesRange
    getAllEmployeesCount(selectedValues: any) {
        this.leadService.getAllEmployeesCount().then(count => {
            let resValue = count.filter(el => el.statusId === 1);
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }
    //JobFunction
    getJobFunction(selectedValues: any) {
        this.configService.getContactRoles().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(jobFunctions => {
            let resValue = []
            if (jobFunctions) {
                resValue = jobFunctions.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        });
    }

    getAllCountryTerriList(selectedValues: any) {
        // if (this.territory?.length == 0) {
        //     this.appMainService.isShowSpinner('CountryTerriList');
        //     this.ruleService.getTerritoryCountryListDetail(true).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
        //         this.appMainService.isHideSpinner('CountryTerriList');
        //         let terriCountries = res ?? [];
        //         if (terriCountries) {
        //             terriCountries = terriCountries.filter(x => x?.children?.length > 0);
        //             this.territory = terriCountries;
        //         }
        //     },
        //         error => {
        //             this.appMainService.isHideSpinner('CountryTerriList');
        //         });
        // }

    }

    loadContactRoles(selectedValues: any): void {
            this.appMainService.isShowSpinner('contactRoles');
            this.configService.getNewAllContactRoles().subscribe({
            next: (resp: any[]) => {
               const contactRoles :any = resp?.length ? resp : [];
               this.setDropDownValue(contactRoles, selectedValues);
               this.appMainService.isHideSpinner("contactRoles");
            },
            error: (err) => {
                this.appMainService.isHideSpinner('contactRoles');
            }
            });
        }

    getAllAccountTypes(selectedValues: any) {
        this.ruleService.getAllAccountTypes(AccountGroupId.ID).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }

    getAllTags(selectedValues: any) {
        this.ruleService.getAllTags().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(tags => {
            let resValue = [];
            if (tags) {
                tags = tags?.filter(x => x?.statusId == 1);
                resValue = tags.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }

    //#region ***Opportunity Dropdown***

    //#endregion

    //#region ******Estimate Dropdown******
    getAllWarehouse(selectedValues: any) {
        this.savedSearchesService.getAllWarehouse().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getPaymentTermList(selectedValues: any) {
        this.paymenttermService.getPaymentTermList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getVendorPaymentTermList(selectedValues: any) {
        this.paymenttermService.getPaymentTermList(3).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getPaymentMrthodList(selectedValues: any) {
        this.paymentmethodService.getPaymentMrthodList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }

    getVendorPaymentMrthodList(selectedValues: any) {
        this.paymentmethodService.getPaymentMrthodList(3).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getShippingTermList(selectedValues: any) {
        this.shippingtermService.getShippingTermList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getShippingMethodList(selectedValues: any) {
        this.shippingmethodService.getShippingMethodList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }

            const treeList = this.utilityService.prepareShippingMethods(res);
            this.dropdownValues = treeList;

            if((typeof selectedValues)=='object'){
                if(selectedValues?.id>0){
                    const addedList: any = this.utilityService.findShippingMethodById(this.dropdownValues, selectedValues?.id)
                    this.fieldDetailsForm.patchValue({
                        newValue: addedList
                    })
                }
            }

            // this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }

    getShippingMethodFlatList(selectedValues: any) {
        this.shippingmethodService.getShippingMethodList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.filter(x=> x.statusId==Status.Active).map(x => ({ id: x.id, name: x.name }));
            }

            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }

    getConfigData(type, moduleName, selectedValues) {
        this.savedSearchesService.getConfigurationsByModule(moduleName).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(config => {
            //Product Channels
            const productChannel = config.filter(config => config.name == 'Product Type')[0];
            const producttypes = JSON.parse(productChannel.configurationDetails[0].configJSONValue);
            const channels = producttypes.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(channels, selectedValues);
        }, err => {
        });
    }

    getBrandList(selectedValues) {
        this.savedSearchesService.getBrandList().subscribe((brands) => {
            if (brands) {
                brands = brands.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(brands, selectedValues);
            }
        });
    }

    getVendor(type, selectedValues) {
        this.savedSearchesService.getvendorsDD().subscribe((vendor) => {
            const preferredVendor = (vendor?.filter(v => v.typeName?.includes('Manufacturer')));
            if (type == 'vendor') {
                vendor = vendor.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(vendor, selectedValues);
            } else {
                const prefVendor = preferredVendor.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(prefVendor, selectedValues);
            }
        });
    }

    getVendorTypes(groupId: number, selectedValues: any) {
        this.productsService.getAllGroupTypes(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }

    getVendorBusinessClassification(groupId: number, selectedValues: any) {
        this.productsService.getAllGroupTypes(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }

    getInventoryGroup(type, selectedValues) {
        this.savedSearchesService.getInventoryGroups().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            if (res?.length) {
                const inventoryGroups = res;
                if (type == 'tax' || type == 'discount') {
                    const taxGroup = inventoryGroups?.filter(grp => grp.name == 'Discount Type')[0];
                    this.getAllTax(taxGroup?.id, selectedValues);
                } else if (type == 'variant') {
                    const variantGroup = inventoryGroups?.filter(grp => grp.name == 'Product Group')[0];
                    this.getAllProductVariant(variantGroup?.id, selectedValues);
                } else if (type == 'height' || type == 'weight') {
                    const uomGroup = inventoryGroups?.filter(grp => grp.name == 'UnitOfMeasure')[0];
                    this.getAllUOM(type, uomGroup?.id, selectedValues);
                } else if (type == 'category') {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Product Category')[0];
                    this.getProductCategory(categoryGroup?.id, selectedValues)
                } else if(type == 'warranty'){
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Warranty')[0];
                    this.getInventoryWarrenty(categoryGroup?.id, selectedValues);
                } else if(type == 'color'){
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Product Color')[0];
                    this.loadItemColors(categoryGroup?.id, selectedValues);
                } else if (type == 'vendorstype') {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Vendor Type')[0];
                    this.getVendorTypes(categoryGroup?.id, selectedValues)
                } else if (type == 'ddbusiness') {
                    const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Account Category')[0];
                    this.getVendorBusinessClassification(categoryGroup?.id, selectedValues)
                }
            }
        }, err => {
        });
    }

    loadAllFinancialAccounts(type, selectedValues: any) {
        this.productsService.getAllFinancialAccounts().subscribe(accounts => {
            let data = []
            for (let c of accounts) {
                let ChildData = [];
                for (let s of c.childAccounts) {
                    let subData = [];
                    for (let subb of s.childAccounts) {
                        let childSubbData = [];
                        for(let subChild of subb.childAccounts){
                            if (subChild.statusId == 1) {
                                let eachSubChild: any = {
                                    label: subChild.name,
                                    value: subChild,
                                    children: [],
                                };
                                childSubbData.push(eachSubChild);
                            }
                        }
                        if (subb.statusId == 1) {
                            let eachSub = {
                                label: subb.name,
                                value: subb,
                                children: childSubbData,
                            };
                            subData.push(eachSub);
                        }
                    }
                    if (s.statusId == 1) {
                        let eachSub = {
                            label: s.name,
                            value: s,
                            children: subData
                        }
                        ChildData.push(eachSub)
                    }
                }
                if (c.statusId == 1) {
                    let eachData = {
                        label: c.name,
                        value: c,
                        children: ChildData
                    }
                    data.push(eachData)
                }
            }
            const financialAccounts = data;
            this.dropdownValues = financialAccounts?.filter(
                (acc) => acc.label == type
            );

            if(selectedValues){
                this.getSavedFinancialAccount(this.dropdownValues, selectedValues);
            }
        });
    }

    getAllClass(selectedValues: any) {
        this.productsService.getClasses().subscribe((cls) => {
            let data = []
            for (let c of cls) {
                let ChildData = [];
                for (let s of c.childClass) {
                    let subData = [];
                    for (let subb of s.childClass) {
                        let childSubbData = [];
                        if (subb.statusId == 1) {
                            let eachSub = {
                                label: subb.name,
                                value: subb,
                                children: childSubbData,
                            };
                            subData.push(eachSub);
                        }
                    }
                    if (s.statusId == 1) {
                        let eachSub = {
                            label: s.name,
                            value: s,
                            children: subData
                        }
                        ChildData.push(eachSub)
                    }
                }
                if (c.statusId == 1) {
                    let eachData = {
                        label: c.name,
                        value: c,
                        children: ChildData
                    }
                    data.push(eachData)
                }
            }
            this.dropdownValues = data;
            if (selectedValues) {
                this.getSavedFinancialAccount(this.dropdownValues, selectedValues)
            }
        });
    }

    getUnitOfMeasures(selectedValues: any) {
        this.productsService.getAllMeasurements().subscribe((units) => {
            let data = []
            for (let c of units) {
                let ChildData = [];
                for (let s of c.childUOM) {
                    let subData = [];
                    for (let subb of s.childUOM) {
                        let childSubbData = [];
                        if (subb.statusId == 1) {
                            let eachSub = {
                                label: subb.name,
                                value: subb,
                                children: childSubbData,
                            };
                            subData.push(eachSub);
                        }
                    }
                    if (s.statusId == 1) {
                        let eachSub = {
                            label: s.name,
                            value: s,
                            children: subData
                        }
                        ChildData.push(eachSub)
                    }
                }
                if (c.statusId == 1) {
                    let eachData = {
                        label: c.name,
                        value: c,
                        children: ChildData
                    }
                    data.push(eachData)
                }
            }
            this.dropdownValues = data;
            if (selectedValues) {
                this.getSavedFinancialAccount(this.dropdownValues, selectedValues)
            }
        });
    }

    getProductCategory(productcatId, selectedValues: any) {
        this.productsService
            .getAllProductCategoryList(productcatId)
            .subscribe((cat) => {
                // Category Tree
                let cateData = [];
                for (let children of cat) {
                    let childrenData = [];
                    for (let sub of children.childCategory) {

                        let subData = [];
                        for (let subb of sub.childCategory) {
                            let childSubbData = [];
                            for (let childsubb of subb.childCategory) {
                                if (childsubb.statusId == 1) {
                                    let eachSubb = {
                                        label: childsubb.name,
                                        value: childsubb,
                                        children: [],
                                    };
                                    childSubbData.push(eachSubb);
                                }
                            }
                            if (subb.statusId == 1) {
                                let eachSub = {
                                    label: subb.name,
                                    value: subb,
                                    children: childSubbData,
                                };
                                subData.push(eachSub);
                            }
                        }

                        if (sub.statusId == 1) {
                            let eachChildItem = {
                                label: sub.name,
                                value: sub,
                                children: subData,
                            };
                            childrenData.push(eachChildItem);
                        }
                    }

                    if (children.statusId == 1) {
                        let eachItem = {
                            label: children.name,
                            value: children,
                            children: childrenData,
                        };
                        cateData.push(eachItem);
                    }
                }
                this.dropdownValues = cateData;
                if (selectedValues) {
                    this.getSavedFinancialAccount(this.dropdownValues, selectedValues, 'multiple')
                }
            });
    }

    getAllTax(groupId, selectedValues: any) {
        this.savedSearchesService.getAllTax(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            res = res.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(res, selectedValues);
        }, err => {
        });
    }

    getAllProductVariant(groupId, selectedValues: any) {
        this.productsService.getInventoryVariantGroups(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            if (res) {
                res = res.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(res, selectedValues);
            }
        }, err => {
        });
    }

    getInventoryWarrenty(groupId, selectedValues: any) {
        this.productsService.getAllWarranty(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            if (res) {
                res = res.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(res, selectedValues);
            }
        }, err => {
        });
    }

    loadItemColors(groupId, selectedValues: any) {
        this.productsService.getAllItemColor(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            if (res) {
                res = res.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(res, selectedValues);
            }
        }, err => {
        });
    }

    getAllUOM(type, groupId, selectedValues: any) {
        this.savedSearchesService.getInventoryCategory(groupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
            if (type == 'height') {
                const heightType = types.filter((s) => s.name == 'Length')[0];
                this.getUOMByCategory(heightType?.id, selectedValues);
            } else {
                const weightType = types.filter((s) => s.name == 'Weight')[0];
                this.getUOMByCategory(weightType?.id, selectedValues);
            }
        }, err => {
        });
    }

    getUOMByCategory(categoryId, selectedValues) {
        this.savedSearchesService.getUOMByCategory(categoryId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
            types = types.map(x => ({ id: x.id, name: x.name }));
            this.setDropDownValue(types, selectedValues);
        }, err => {
        });
    }

    searchAllProductAutoComplateData(event: any, selectedValues: any, field) {
        this.savedSearchesService.getAllAutoCompleteData(this.selectedChannelId, field?.toLowerCase(), event.query)
            .subscribe(data => {
                this.setDropDownValue(data, selectedValues);
            });
    }

    getAccountList(selectedValues: any, editedRule: SavedSearchNS.IRuleList) {
        // if (editedRule) {
        //     if (this.lastRuleValues.allEnumMultiselect && editedRule.value) {
        //         this.lastRuleValues.allEnumMultiselect.push(...editedRule.value);
        //     }
        // }
    }
    getProductMinified(selectedValues: any) {
        this.savedSearchesService.getProductMinified().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res?.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getOpportunitySources(selectedValues: any) {
        this.savedSearchesService.getOpportunitySources(this.app.user.organizationId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res?.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getOpportunityRatings(selectedValues: any) {
        this.savedSearchesService.getOpportunityRatings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            let resValue = [];
            if (res) {
                resValue = res?.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(resValue, selectedValues);
        }, err => {
        });
    }
    getEstimateStatus(selectedValues: any) {
        this.setDropDownValue(EstimateStatusObjects, selectedValues);
    }
    getInvoiceStatus(selectedValues: any) {
        this.setDropDownValue(InvoiceStatusObjects, selectedValues);
    }
    getOrderStatus(selectedValues: any) {
        this.setDropDownValue(OrderStatusObjects, selectedValues);
    }
    getPaymentStatus(selectedValues: any) {
        this.setDropDownValue(InvoicePaymentStatusEnumObjects, selectedValues);
    }
    getShipmentStatus(selectedValues: any) {
        this.setDropDownValue(ShipmentStatusObjects, selectedValues);
    }
    getSalesOrderStatus(selectedValues: any) {
        this.setDropDownValue(SalesOrderStatusEnumObjects, selectedValues);
    }
    getSalesOrderStage(selectedValues: any) {
        this.setDropDownValue(SalesOrderStageEnumObjects, selectedValues);
    }
    getTaxablePreference(selectedValues: any) {
        this.setDropDownValue(TaxPreferenceObjects, selectedValues);
    }

    setParentSelectedAccount(selectedValues: any){
        if(selectedValues?.name){
            this.searchAllAccounts({query: selectedValues.name}, selectedValues);
        }
    }
    // Search Parent Accounts
    searchAllAccounts(event: any, selectedValues: any, channelId: number = 0) {
        let data = {
            currentPage: 0,
            pageSize: 0,
            organizationId: this.app.user.organizationId,
            loginUserId: this.app.user.userId,
            search: event.query,
            channelId: channelId||this.selectedAccountChannel?.id||0
        };

        this.accountsHttpService.getAllAccounts(data)
            .then(accounts => {
                let activeAccounts = accounts?.filter(obj => obj.statusId == 1 && obj.name.length);
                // this.parentAccounts = activeAccounts;
                this.setDropDownValue(activeAccounts, selectedValues);
            });
    }

    onChangeAccountChannel() {

    }

    getSavedFinancialAccount(list, selectedValue: any, selection: 'single'|'multiple' = 'single') {
        // console.log(list, savedParam)
        const filteredCategories = [];
        let savedParam = [];

        if(selection=='single' && selectedValue){
            savedParam.push(selectedValue)
        }else{
            savedParam = selectedValue;
        }

        savedParam.forEach((element) => {
            const cat = list.filter(
                (cat) => cat.value?.id == element.id
            )[0];
            if (cat) {
                filteredCategories.push(cat);
            }
        });
        savedParam.forEach((element) => {
            list.forEach((cat) => {
                const childCat = cat.children.filter(
                    (child) => child.value?.id == element.id
                )[0];
                if (childCat) {
                    filteredCategories.push(childCat);
                }
            });
        });
        savedParam.forEach((element) => {
            list.forEach((cat) => {
                cat.children.forEach((childCat) => {
                    const subChildCat = childCat.children.filter(
                        (child) => child.value?.id == element.id
                    )[0];
                    if (subChildCat) {
                        filteredCategories.push(subChildCat);
                    }
                });
            });
        });
        savedParam.forEach((element) => {
            list.forEach((cat) => {
                cat.children.forEach((childCat) => {
                    childCat.children.forEach((childSub) => {
                        const childSubChildCat = childSub.children.filter(
                            (child) => child.value?.id == element.id
                        )[0];
                        if (childSubChildCat) {
                            filteredCategories.push(childSubChildCat);
                        }
                    });
                });
            });
        });

        if(selection=='single' && filteredCategories?.length>0){
            this.fieldDetailsForm.patchValue({
                newValue: filteredCategories[0]
            });
        }else if(filteredCategories?.length>0){
            this.fieldDetailsForm.patchValue({
                newValue: filteredCategories
            });
        }

    }
    //#endregion

    onNodeSelect(event) {
        const node = event.node;
        if (!node.parent) {
            const selectedNodes = [node];
            setTimeout(()=>{
                this.fieldDetailsForm.patchValue({
                    newValue: selectedNodes
                },{onlySelf: true, emitEvent: false});
            })
        } else {
            const parentSelected = this.fieldDetailsForm.getRawValue().newValue?.length>0 ? this.fieldDetailsForm.getRawValue().newValue.find(n => n.value.id == node.parent?.value?.id) : null;
            const selectedNodes = this.fieldDetailsForm.getRawValue().newValue?.length>0 ? this.fieldDetailsForm.getRawValue().newValue : [];
            if(parentSelected){
                selectedNodes.push(node);
            }

            setTimeout(()=>{
                this.fieldDetailsForm.patchValue({
                    newValue: selectedNodes
                },{onlySelf: true, emitEvent: false});
            });
        }
    }

    onNodeUnselect(event) {
        const node = event.node;
        let selectedNodes = null;
        if (node.parent) {
            selectedNodes = this.fieldDetailsForm.getRawValue().newValue.filter(n => n.value.id != node.value.id);
        }

        setTimeout(()=>{
            this.fieldDetailsForm.patchValue({
                newValue: selectedNodes
            },{onlySelf: true, emitEvent: false});
        })
    }

    onChangeAssign(event: any) {
        if (event?.node?.hasChildTerritorys) {
            //this.getTerritory(event?.node);
        }
    }
    onNodeExpand(event: any) {
        // console.log(this.lastRuleValues.selectedValue, event);
        if (event?.node?.hasChildTerritorys) {
            //this.getTerritory(event);
        }
    }

    setDropDownValue(dropDownValue: any[], selectedValues: any) {
        this.dropdownValues = [];

        if(dropDownValue?.length>0){
            dropDownValue.map(value=>{
                this.dropdownValues.push({
                    id: value?.id,
                    name: value?.name
                })
            })
        }

        if((typeof selectedValues)=='object'){
            if(selectedValues?.id>0){
                const addedList: any = this.dropdownValues.find(c=> c?.id==selectedValues?.id)||[];
                this.fieldDetailsForm.patchValue({
                    newValue: addedList
                })
            }
        }else{
            if(selectedValues?.length>0){
                const addedList: any[] = [];

                selectedValues.map(addedValue=>{
                    const exist = this.dropdownValues.find(c=> c?.id==addedValue?.id);

                    if(exist){
                        addedList.push(exist);
                    }
                });

                this.fieldDetailsForm.patchValue({
                    newValue: addedList
                })
            }
        }

    }
    //#endregion

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    dialogClose(){
        const newValueCtl = this.fieldDetailsForm.controls['newValue'];
        newValueCtl.disable();
        this.initFieldForm();
        this.displayAddField = false;
        this.dialogClosed.emit(true);
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    handleKeyDown(event: KeyboardEvent, inputValue: string) {
        const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
        if (allowedKeys.includes(event.key) || /\d/.test(event.key)) {
            return; // Allow input
        }

        // Allow only one dot or comma
        if ((event.key === '.') && !inputValue?.toString()?.includes(event.key)) {
            return; // Allow input
        }

        event.preventDefault(); // Block invalid input
    }

    //#region ***Add Expression***

    updatedAddedTags(value: string){
        this.addedFieldTags = [];
        if(value){
            const addedTags: string[] = value.match(customFieldTagRegex)||[];
            addedTags.map(labelName=>{
                const exist = this.availableFieldsForExpression.find(field=>field.labelname.trim()==labelName.trim());

                if(exist){
                    if(!this.addedFieldTags.includes(exist.labelname))
                        this.addedFieldTags.push(exist.labelname);
                }
            })
        }
    }

    openExpressionAdd(){
        this.expressionText = "";

        if(this.fieldDetailsForm.getRawValue().fieldValueType== WorkflowModelsNS.WorkflowUpdateFieldValueType.Expression && this.fieldDetailsForm.getRawValue().newValue){
            this.expressionText = this.fieldDetailsForm.getRawValue().newValue;
        }

        this.displayAddExpression = true;
    }

    saveExpression(expressionData: {expressionText: string, addedFieldTags: string[]}){
        this.fieldDetailsForm.patchValue({
            newValue: expressionData.expressionText,
            fieldDataType: 'String',
            fieldValueType: WorkflowModelsNS.WorkflowUpdateFieldValueType.Expression
        });
        this.updatedAddedTags(expressionData.expressionText);
    }

    removeExpression(){
        this.fieldDetailsForm.patchValue({
            fieldValueType: WorkflowModelsNS.WorkflowUpdateFieldValueType.Value
        });

        this.setSectionCustomPayload();
    }

    expressionDialogClose(){
        this.displayAddExpression = false;
    }

    //#endregion ***Add Expression***

    isPatternInvalid(form: FormGroup, formControlName: string): boolean {
        const control = form?.get(formControlName);
        return control.hasError('pattern') && control?.touched;
    }

    loadAllVendorList(selectedValues: any) {
        this.purchaseService.getVendorList().pipe(
          switchMap(() => this.purchaseService.getAllPOVendors()),
          takeUntil(this.ngUnsubscribe$)
        ).subscribe({
          next: (res) => {
            const resValue = res?.map(x => ({ id: x.id, name: x.name })) || [];
            this.setDropDownValue(resValue, selectedValues);
          },
          error: (err) => {
          }
        });
      }

    generateAvailableFieldsForExpressionFromParentModules() {
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedTemplateService.getTemplateSectionsForFormBuild(this.selectedParentModule?.objectId, this.selectedParentTemplate?.channelId).subscribe(
            {
                next: (response) => {
                    let columnList = response || [];
                    columnList.map((fields, i) => [
                        fields.customFields.map((customFields, i) => {
                            const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                            customFields = {
                                ...customFields,
                                formControl: formControlDetails?.type,
                                formControlDetails: formControlDetails,
                                isCustom: true
                            }

                            fields.customFields[i] = customFields;
                        })
                    ]);
                    this.generateAvailableFieldsFromParentModules(columnList, 'parentModules');
                    this.appMainService.isHideSpinner('getColumnSettings');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getColumnSettings');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            });
    }


    generateAvailableFieldsFromParentModules(columnList: any[], type: string) {
        this.availableFieldsForExpression = [];
        columnList.map(sectionDetails => {
            if (!sectionDetails?.systemGenerated || sectionDetails.name.toLowerCase().includes('information') || (sectionDetails.name.toLowerCase().includes('details') && !sectionDetails.name.toLowerCase().includes('address'))) {
                sectionDetails.fields.filter(f => !this.hiddenChildFields.includes(f.field)).map(field => {
                    if (field?.childFields?.length > 0) {
                        field.childFields.map(childField => {
                            this.setFieldDetails(childField, type , this.selectedParentModule);
                        })
                    } else {
                        this.setFieldDetails(field, type, this.selectedParentModule);
                    }
                });

                sectionDetails.customFields.map(field => {
                    this.setFieldDetails(field, type , this.selectedParentModule);
                });
            }
        });
    }
}
